import { forwardRef, type SVGProps } from 'react';

export const ArticleErrorIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function ArticleErrorIcon(props, ref) {
  return (
    <svg
      ref={ref}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M20.1451 17.4927C20.4568 17.3224 20.6613 16.9918 20.6613 16.6112V7.5955C20.6613 7.21484 20.4568 6.88427 20.1451 6.71397L12.4512 2.26625C12.2954 2.14604 12.1006 2.08594 11.8961 2.08594C11.6916 2.08594 11.4968 2.14604 11.3409 2.26625L3.64704 6.71397C3.33538 6.88427 3.13086 7.21484 3.13086 7.5955V16.6112C3.13037 16.7926 3.17823 16.9707 3.26923 17.1261C3.36023 17.2815 3.4909 17.4083 3.64704 17.4927L11.3409 21.9404C11.4968 22.0606 11.6916 22.1207 11.8961 22.1207C12.1006 22.1207 12.2954 22.0606 12.4512 21.9404L20.1451 17.4927ZM6.0916 7.5955L11.8961 4.2397L17.7007 7.5955L11.8961 10.9513L6.0916 7.5955ZM14.6369 16.8954L16.5 15.0323L18.3631 16.8954C18.4328 16.9651 18.5215 17 18.6293 17C18.737 17 18.8257 16.9651 18.8954 16.8954C18.9651 16.8257 19 16.737 19 16.6293C19 16.5215 18.9651 16.4328 18.8954 16.3631L17.0323 14.5L18.8954 12.6369C18.9651 12.5672 19 12.4785 19 12.3707C19 12.263 18.9651 12.1743 18.8954 12.1046C18.8257 12.0349 18.737 12 18.6293 12C18.5215 12 18.4328 12.0349 18.3631 12.1046L16.5 13.9677L14.6369 12.1046C14.5672 12.0349 14.4785 12 14.3707 12C14.263 12 14.1743 12.0349 14.1046 12.1046C14.0349 12.1743 14 12.263 14 12.3707C14 12.4785 14.0349 12.5672 14.1046 12.6369L15.9677 14.5L14.1046 16.3631C14.0349 16.4328 14 16.5215 14 16.6293C14 16.737 14.0349 16.8257 14.1046 16.8954C14.1743 16.9651 14.263 17 14.3707 17C14.4785 17 14.5672 16.9651 14.6369 16.8954Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
});
